import type { SingleEditProps } from '../types'

import { LimitedAccess } from '../fields/Access'
import { Companies } from '../fields/Companies'
import { CourierTerritoryAccess } from '../fields/CourierTerritoryAccess'
import { CourierTerritoryDataAccess } from '../fields/CourierTerritoryDataAccess'
import { Email } from '../fields/Email'
import { Name } from '../fields/Name'
import { Password } from '../fields/Password'
import { Surname } from '../fields/Surname'
import { TerritoryFilter } from '../fields/TerritoryFilter'
import { Type } from '../fields/Type'
import { Username } from '../fields/Username'

import { Divider } from '@mui/material'
import { useFieldsVisibility } from '../hooks/useFieldsVisibility'

import { form } from '../formState'

type Props = SingleEditProps & {
  territoriesData: uui.domain.client.rm.TerritoriesDriversAndVehicles
  territoryNames: Record<string, string>
}

export function FormContent(props: Props) {
  const { creating, territoriesData, territoryNames } = props
  const { canShow } = useFieldsVisibility(creating)

  return (
    <>
      <Name />
      <Surname />
      <Email />
      <Username />
      {canShow.password && <Password />}
      <Divider />
      <Type />
      {canShow.companies && <Companies creating={creating} />}
      {canShow.limitedAccess && <LimitedAccess />}
      {canShow.territoryFilter && <TerritoryFilter />}
      {canShow.courier && (
        <form.Fieldset>
          <CourierTerritoryAccess
            territoriesData={territoriesData}
            territoryNames={territoryNames}
          />
          <CourierTerritoryDataAccess
            territoriesData={territoriesData}
            territoryNames={territoryNames}
          />
        </form.Fieldset>
      )}
    </>
  )
}
